<script>
  import { onMount } from "svelte";
  import { Router, Route } from "svelte-routing";
  import Home from "./Home.svelte";
  import CookieConsent from "./CookieConsent.svelte";

  let showModal = false;

  // Functie om te controleren of cookies zijn geaccepteerd
  const checkCookies = () => {
    const consentGiven = localStorage.getItem("cookieConsent");
    if (!consentGiven) {
      showModal = false;
    }
  };

  const acceptCookies = () => {
    localStorage.setItem("cookieConsent", "true");
    showModal = false;
    console.log("User accepted cookies!");
  };

  onMount(() => {
    checkCookies();
  });
</script>

<main>
  <Router>
    <Route path="*" component={Home} />
  </Router>

  <!-- Cookie Consent Modal component -->
  <CookieConsent {showModal} onAccept={acceptCookies} />
</main>

<style>
  :global(body) {
    margin: 0;
    padding: 0;
    background-color: var(--backgroundColor);
    color: var(--textColor);
    font-size: 1.2em;
    font-family: var(--sansSerif);
    line-height: 1.62em;
    word-wrap: break-word;
  }

  main {
    max-width: 650px;
    margin: 50px auto 20px auto;
  }

  @media (max-width: 768px) {
    main {
      max-width: 90vw;
      margin: 35px auto;
    }
  }
</style>
